import React from 'react';

const Modal = ({ children, onClose }) => {

    const modalOverlayStyle = {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 10000,
        overflow: 'auto',
        padding: '20px',
        boxSizing: 'border-box',
    };

    const modalContentStyle = {
        backgroundColor: '#fff',
        padding: '20px',
        borderRadius: '8px',
        boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)',
        position: 'relative',
        // maxWidth: '100%',
        // maxHeight: '100vh',
        overflowY: 'auto',
        boxSizing: 'border-box',
        margin: 'auto',
    };

    const handleContentClick = (e) => {
        e.stopPropagation();
    };
        
    return (
        <div style={modalOverlayStyle} onClick={onClose}>
            <div style={modalContentStyle} onClick={handleContentClick}>
                {children}
            </div>
        </div>
    );
};

export default Modal;
